import React, { useState } from "react";
import headers from "../../Data/Tables/Report/headers";
import Header from "../../Componets/Header";
import Menus from "../../Componets/Menus";
import ProductIcon from "../../Assets/Svg/products";
import InventoryIcon from "../../Assets/Svg/inventory";
import BillingIcon from "../../Assets/Svg/billing";
import SalesIcon from "../../Assets/Svg/sales";
import PurchaseIcon from "../../Assets/Svg/purchase";
import ExpenseIcon from "../../Assets/Svg/expense";
import CustomerIcon from "../../Assets/Svg/customer";
import SupplierIcon from "../../Assets/Svg/supplier";
import ScrollWrapper from "../../Componets/ScrollWrapper";
import {
  SolutionOutlined
} from "@ant-design/icons";



const Reports = () => {
  const [header, setHeader] = useState(headers);

  const formdata = async (data) => {
    console.log(data);
  };

  const menu = [
    {
      icon: <ProductIcon />,
      name: "Products stock",
      description: "View products report",
      url: "/app/reports/products",
    },
    {
      icon: <ProductIcon />,
      name: "Products low stock",
      description: "View products low stock report",
      url: "/app/reports/products/low/stock",
    },
    {
      icon: <ProductIcon />,
      name: "Products out of stock",
      description: "View products out of stock report",
      url: "/app/reports/products/out/of/stock",
    },
    {
      icon: <ProductIcon />,
      name: "Products fast moving",
      description: "View products fast moving report",
      url: "/app/reports/products/fast/moving",
    },
    {
      icon: <ProductIcon />,
      name: "Products top selling",
      description: "View products top selling report",
      url: "/app/reports/products/top/selling",
    },
    {
      icon: <ProductIcon />,
      name: "Products ageing",
      description: "View products ageing reports",
      url: "/app/reports/products/ageing",
    },
    {
      icon: <ProductIcon />,
      name: "Products received ageing",
      description: "View products received ageing reports",
      url: "/app/reports/products/received/ageing",
    },
    {
      icon: <ProductIcon />,
      name: "Products reports",
      description: "View products report",
      url: "/app/reports/products/reports",
    },

    // {
    //   icon: <ProductIcon />,
    //   name: "Product sold",
    //   description: "View product sale report",
    //   url: "/app/reports/products/sold",
    // },
    // {
    //   icon: <ProductIcon />,
    //   name: "Product purchase",
    //   description: "View product purchase report",
    //   url: "/app/reports/products/purchase",
    // },

    {
      icon: <InventoryIcon />,
      name: "Inventory",
      description: "View inventory report",
      url: "/app/reports/inventory",
    },
    {
      icon: <InventoryIcon />,
      name: "Inventory near expiry",
      description: "View inventory near expiry report",
      url: "/app/reports/inventory/near/expiry",
    },
    {
      icon: <InventoryIcon />,
      name: "Inventory expired",
      description: "View inventory expired report",
      url: "/app/reports/inventory/expired",
    },
    {
      icon: <InventoryIcon />,
      name: "Transfers report",
      description: "View transfer report",
      url: "/app/reports/transfers",
    },
    {
      icon: <BillingIcon />,
      name: "Sales VAT",
      description: "View sales tax report",
      url: "/app/reports/sales/vat",
    },
    {
      icon: <BillingIcon />,
      name: "Purchase VAT",
      description: "View purchase tax report",
      url: "/app/reports/purchase/vat",
    },
    {
      icon: <BillingIcon />,
      name: "VAT Summary",
      description: "View tax summary report",
      url: "/app/reports/summary/vat",
    },

    {
      icon: <SalesIcon />,
      name: "Sales",
      description: "View sales report",
      url: "/app/reports/sales",
    },
     {
      icon: <SalesIcon />,
      name: "Sales Return",
      description: "View sales return report",
      url: "/app/reports/sales-return",
    },
    {
      icon: <SalesIcon />,
      name: "Net Sales",
      description: "View net sales report",
      url: "/app/reports/sales/net",
    },

    {
      icon: <PurchaseIcon />,
      name: "Purchases",
      description: "View purchases report",
      url: "/app/reports/purcases",
    },
    {
      icon: <PurchaseIcon />,
      name: "Purchase Returns",
      description: "View purchase returns report",
      url: "/app/reports/purchase-returns",
    },
    {
      icon: <ExpenseIcon />,
      name: "Expenses",
      description: "View expenses report",
      url: "/app/reports/expenses",
    },
    {
      icon: <ExpenseIcon />,
      name: "Cash Closing Report",
      description: "View Daily Cash Closures report",
      url: "/app/reports/cashClosing",
    },

    {
      icon: <ExpenseIcon />,
      name: "Daily Sales Report",
      description: "View Daily Sales  report",
      url: "/app/reports/dailySales",
    },
    {
      icon: <ExpenseIcon />,
      name: "Received Orders Report",
      description: "View Received Orders report",
      url: "/app/reports/receivedorders",
    },

    {
      icon: <SolutionOutlined />,
      name: "Customer-wise Sales & Returns Ageing Report",
      description: "View Customer-wise Sales & Returns with Payment Status Report",
      url: "/app/reports/customer-wise-sale-and-return-ageing",
    },

    // {
    //   icon: <CustomerIcon />,
    //   name: "Customer",
    //   description: "View customer report",
    //   url: "/app/reports/customers",
    // },
    // {
    //   icon: <SupplierIcon />,
    //   name: "Suppliers",
    //   description: "View suppliers report",
    //   url: "/app/reports/suppliers",
    // },
  ];

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <ScrollWrapper>
        <div className="mt-4 grid grid-cols-4 gap-4">
          {menu?.map((value, index) => {
            return (
              <Menus
                className="flex bg-white p-4 rounded-lg border cursor-pointer setting-card hover:bg-gray-100"
                icon={value?.icon}
                name={value?.name}
                description={value?.description}
                url={value?.url}
              />
            );
          })}
        </div>
      </ScrollWrapper>
    </Header>
  );
};

export default Reports;
